import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './auth';
import './i18n';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element with id="root" not found in the document.');
}

/**
 * AuthProvider wraps the app with MSAL so Entra ID tokens are available.
 * In dev/local (when VITE_ENTRA_CLIENT_ID is empty), MSAL will be
 * initialized but no login will be triggered — the app works unauthenticated.
 */
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
